module.exports = __webpack_public_path__ + "assets/img/icon6-menu.eaa04e3d.svg";